import React from "react";
import { Row, Container } from "reactstrap";

function TopRangeFooter() {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <div className="credits ml-auto">
            <span className="copyright">
              © {new Date().getFullYear()}, АО "ТопРендж"
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default TopRangeFooter;